import * as React from "react";

function SvgHellobar(props, ref) {
  return (
    <svg
      viewBox="0 0 83.3 54.3"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M191.7 0H1C.4 0 0 .4 0 1v52.3c0 .6.4 1 1 1h190.8c.6 0 1-.4 1-1V1c-.1-.6-.5-1-1.1-1z"
        fill="#fff"
      />
      <path
        d="M191.7 0H1C.4 0 0 .4 0 1v52.3c0 .6.4 1 1 1h190.8c.6 0 1-.4 1-1V1c-.1-.6-.5-1-1.1-1zm-123 19.3h-8.8v15.5h8.8v4.9H45v-4.9h9.2v-6.3H29.1v6.3h9.1v4.9H14.6v-4.9h8.9V19.3h-8.9v-4.7h23.5v4.7H29V24h25.2v-4.7H45v-4.7h23.6v4.7zm121 32H83.3V3h106.5l-.1 48.3z"
        fill="#ed5734"
      />
    </svg>
  );
}

export default React.forwardRef(SvgHellobar);
